var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2Off(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4871 59.3785C24.1788 72.6728 46.0471 72.3463 59.3293 58.6421C72.6115 44.9379 72.2852 23.0497 58.5935 9.75534C44.9018 -3.53258 23.0335 -3.20599 9.75134 10.4918C-3.53727 24.1959 -3.19817 46.0842 10.4871 59.3785Z",
    fill: "#FF8C0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 49.9476C42.9792 49.9476 49.9167 43.0038 49.9167 34.5169C49.9167 26.03 42.9792 19.0862 34.5 19.0862C26.0209 19.0862 19.0834 26.03 19.0834 34.5169C19.0834 43.0038 26.0209 49.9476 34.5 49.9476Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9479 34.5169L32.3108 38.8838L41.052 30.15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Off);
export default __webpack_public_path__ + "static/media/2_off.baa36272f7b1460bda5913d2e38830c5.svg";
export { ForwardRef as ReactComponent };